import React from 'react'
import PropTypes from 'prop-types'

const InputWithPrefix = ({
  input,
  type,
  meta,
  disabled,
  readOnly,
  prefix,
  groupClassName,
  errorClassName,
  prefixClassName = 'border-r-2 px-5 mr-2',
  inputErrorClassName,
  inputClassName,
  onClick,
  placeHolder,
  labelClassName,
  label
}) => {
  const inputGroupClasses = `form-control w-full flex items-center ${
    meta.touched && meta.error ? [inputClassName, inputErrorClassName].join(' ') : inputClassName
  }`

  return (
    <div className={`form-group ${groupClassName}`}>
      {label && <label className={`block ${labelClassName}`}>
        {label}
      </label>}
      <div className={inputGroupClasses}>
        <p className={prefixClassName}>{prefix}</p>
        <input
          {...input}
          placeholder={placeHolder}
          className="flex-1"
          type={type}
          autoComplete="new-password"
          onClick={onClick}
          disabled={disabled}
          readOnly={readOnly}
        />
      </div>
      {meta.touched && meta.error && <p className={`form-error ${errorClassName}`}>{meta.error}</p>}
    </div>
  )
}

InputWithPrefix.propTypes = {
  input: PropTypes.object.isRequired,
  type: PropTypes.string,
  prefix: PropTypes.string,
  meta: PropTypes.object.isRequired,
  groupClassName: PropTypes.string,
  errorClassName: PropTypes.string,
  inputErrorClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  prefixClassName: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  placeHolder: PropTypes.string,
  labelClassName: PropTypes.string,
  label: PropTypes.string
}

export default InputWithPrefix
